import { render } from "./ExerciseManager.vue?vue&type=template&id=3f40e69f&scoped=true"
import script from "./ExerciseManager.vue?vue&type=script&lang=js"
export * from "./ExerciseManager.vue?vue&type=script&lang=js"

import "./ExerciseManager.vue?vue&type=style&index=0&id=3f40e69f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f40e69f"]])

export default __exports__